import { memo } from "react";
import Svg, { Path, type SvgProps } from "react-native-svg";

const SvgEdit = (props: SvgProps) => (
  <Svg fill="none" height={25} width={24} {...props}>
    <Path
      d="M13.393 6.613a1.22 1.22 0 0 1 1.726 0l2.59 2.589a1.22 1.22 0 0 1 0 1.726L7.217 21.419a1.22 1.22 0 0 1-.753.353l-2.848.259a1.22 1.22 0 0 1-1.326-1.326l.26-2.848c.025-.284.15-.55.352-.753zM17.635 2.359a1.22 1.22 0 0 1 1.726 0l2.517 2.516a1.22 1.22 0 0 1 0 1.726l-1.456 1.456a1.22 1.22 0 0 1-1.726 0L16.18 5.541a1.22 1.22 0 0 1 0-1.726z"
      fill={props.color}
    />
    <Path
      clipRule="evenodd"
      d="M19.362 2.359a1.22 1.22 0 0 0-1.727 0L16.18 3.815a1.22 1.22 0 0 0 0 1.726l2.517 2.516a1.22 1.22 0 0 0 1.726 0l1.456-1.456a1.22 1.22 0 0 0 0-1.726z"
      fill={props.color}
      fillRule="evenodd"
    />
  </Svg>
);
const Memo = memo(SvgEdit);
export default Memo;
